import React from "react";
import { Link } from "gatsby";
import { normalizeInternalPath } from "../../utils/normalizeInternalPath";

export default function NavLink({ linkType, path = "", label = "", cls = "" }) {
  if (linkType === "label")
    return <span className={`cursor-pointer ${cls} `}>{label}</span>;
  if (linkType === "external") {
    return (
      <a
        href={path}
        className={`${cls}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        {label}
      </a>
    );
  }

  return (
    <Link to={normalizeInternalPath(path)} className={`${cls}`}>
      {label}
    </Link>
  );
}
